
<template>
<div id="layout_apendices" >
    <div>
        <v-breadcrumbs :items="parametrosAP28.breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-top justify-top>
            <v-menu-lateral-apendice />
            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" :title="parametrosAP28.title" class="px-5 py-3" >
                    <v-card-actions>
                                <v-btn v-if="(permisoEliminarTodos && datosAP28.items.length>0)" dark x-small color="red" @click.native="deleteAll()" 
                                    title="Eliminar Palabras Clave" v-tippy>
                                    <v-icon dark>delete</v-icon> Eliminar Todos
                                </v-btn>
                                <v-spacer></v-spacer>
                                <v-speed-dial direction="left" open-on-hover>
                                    <template v-slot:activator>
                                        <v-btn x-small fab dark color="primary" >
                                            <v-icon>reorder</v-icon>
                                        </v-btn>
                                    </template>
                                    <exportar-excel v-tippy style="cursor: pointer" :data="datafiltered2" :exportFields="parametrosAP28.camposexcel" :name="parametrosAP28.title + '.xlsx'" >
                                        <v-btn fab x-small dark color="success" title="Exportar" v-tippy>
                                            <v-icon dark>get_app</v-icon>
                                        </v-btn>
                                    </exportar-excel>
                                    <upload-excel-component :on-success="handleSuccessAP28" :before-upload="beforeUpload" />
                                    <exportar-excel :data="parametrosAP28.camposLayout" :exportFields="parametrosAP28.encabezadoLayout" :name="'Layout ' + parametrosAP28.title + '.xlsx'" >
                                        <v-btn fab dark x-small color="purple darken-2" title="Descargar Layout" v-tippy>
                                            <v-icon dark>receipt</v-icon>
                                        </v-btn>
                                    </exportar-excel>
                                </v-speed-dial>&nbsp;

                                <v-btn fab dark x-small color="secondary" slot="activator" @click.native="openModalAP28(1)" title="Agregar Registro" v-tippy>
                                    <v-icon dark>add</v-icon>
                                </v-btn>
                            </v-card-actions>
                            <div class="contenedor-tab-reportes" >
                                <v-client-table ref="vuetable2" :data="datosAP28.items" :columns="parametrosAP28.columns" :options="parametrosAP28.options" class="elevation-2 pa-2" >
                                <template slot="noResults" >
                                    <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                                </template>

                                <template slot="actions" slot-scope="props" >
                                    <v-speed-dial v-if="((id_cliente == 0 && props.row.cliente==null) || (props.row.cliente == id_cliente))" direction="left" :open-on-hover="true" >
                                        <v-btn slot="activator" x-small fab dark color="primary" >
                                            <v-icon>reorder</v-icon>
                                        </v-btn>

                                        <v-btn x-small fab dark color="blue" @click.native="getRegistroAP28(props.row.id)" title="Editar Registro" v-tippy>
                                            <v-icon>edit</v-icon>
                                        </v-btn>
                                        <v-btn x-small fab dark color="pink" @click.native="deleteRegistroAP28(props.row.id)" title="Eliminar Registro" v-tippy>
                                            <v-icon>delete</v-icon>
                                        </v-btn>
                                    </v-speed-dial>
                                </template>
                            </v-client-table>
                            </div>
                                        
                                        
                    <v-dialog v-model="modalAP28" max-width="50%" style=" z-index: 400 !important;" >
                        <v-card>
                            <v-card-title>
                                <v-power-titulo :icon="update ? 'edit' : 'add'" :title="update ? 'Actualizar Registro' : 'Nuevo Registro'" tipo="modal" />
                                <v-spacer></v-spacer>
                                <v-btn icon @click.native="modalAP28 = false" class="close_modal" >
                                    <v-icon class="white--text" >cancel</v-icon>
                                </v-btn>
                            </v-card-title>
                            <v-form ref="form" lazy-validation>
                                <v-card-text>
                                    <v-container grid-list-md text-xs-center @keyup.enter="guardarAP28()" >
                                        <v-layout row wrap v-for="(item, index) in this.parametrosAP28.form" :key="index" >
                                            <v-flex s12 m6 l6>
                                                <v-text-field :name="item" :label="item.label" type="text" v-model="item.value" 
                                                v-on:keydown.enter.prevent='1'
                                                @input="item.value = item.value.toUpperCase()" :rules="item.requiered ? [rules.required] : []" :maxlength="item.maxlen" ></v-text-field>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-card-text>
                            </v-form>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn @click.native="modalAP28 = false" >
                                    <v-icon>cancel</v-icon>Cancelar
                                </v-btn>
                                <v-btn color="success" :loading="loading" @click.native="guardarAP28()" >
                                    <v-icon>done</v-icon>
                                    {{ update ? "Actualizar" : "Guardar" }}
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                    
                </base-material-card>
            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>

<script>
import axios from "axios";

import menuLateral from "@/views/apendices/MenuLateralApendice.vue";
import powerTitulo from "@/components/powerTitulo.vue";

export default {
    data: () => ({
        permisoEliminarTodos: false,
        fab: false,        
        name: "datagrid",
        importData: [],
        show_loading: true,
        loading: false,        
        modalAP28: false,          
        update: false,
        url_active: location.href,
        id_cliente: 0,
        editable: true,        
        datosAP28: {
            items: []
        },
        rules: {
            required: v => !!v || "Este campo es requerido"
        },
        parametros: {},
        clientes: [],        
        parametrosAP28: {
            visible:false,
            url_actions: "apendices/",
            url_list: "apendices/lista/",
            tabla: 28,
            title: "PALABRAS CLAVE PARA MÓDULO DE ACTIVO FIJO",
            columns: [
                "clave",                             
                "actions"
            ],
            options: {
                filterable: [
                    "clave",                                      
                ],
                headings: {
                    clave: "Palabras Clave",                 
                    actions: "Operaciones"
                }
            },
            camposexcel: {
                "Palabras Clave": "clave",                
            },
            encabezadoLayout: {
                clave: "clave",                
            },
            camposLayout: [{
                clave: "[Palabras Clave]",                
            }],
            model: {
                id: 0,
                clave: "", 
                cliente: "",                            
            },
            form: {
                clave: {
                    requiered: true,
                    label: "Palabras Clave",
                    value: "",
                    maxlen: 250
                },                
            },
            breadcrumbs: [{
                    text: "Inicio",
                    disabled: false,
                    to: "/home"
                },
                {
                    text: "Utilerías",
                    disabled: true,
                    to: ""
                },
                {
                    text: "Apendices",
                    disabled: true,
                    to: ""
                }
            ]
        },
    }),
    components: {
        "v-power-titulo": powerTitulo,
        "v-menu-lateral-apendice": menuLateral
    },
    computed: {
        datafiltered2() {
            if (this.$refs.vuetable2 != null) {
                return this.$refs.vuetable2.allFilteredData;
            } else {
                return this.datosAP28.items;
            }
        }
    },
    methods: {
        openModalAP28: function (type) {
            if (type === 1) {
                this.limpiarModelAP28();
                this.update = false;
            } else {
                this.update = true;
            }
            this.modalAP28 = true;
        },       
        limpiarModelAP28: function () {
            for (var k in this.parametrosAP28.model) {
                this.parametrosAP28.model[k] = "";
            }
            for (var k in this.parametrosAP28.model) {
                if (Object.keys(this.parametrosAP28.form).includes(k))
                    this.parametrosAP28.form[k].value = "";
            }            
        },        
        guardarAP28() {
            var datos = this.parametrosAP28.model;
            datos["tabla"] = this.parametrosAP28.tabla;
            let id_cliente = this.$local_storage.get("id_cliente");
            var obj = this.parametrosAP28.form;
            for (var [key, valores] of Object.entries(obj)) {
                datos[key] = valores.value;
                datos["cliente"] = id_cliente == 0 ? null : id_cliente;
            }

            if (!this.$refs.form.validate()) {
                //Alguna operación o mensaje
            } else {
                this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
                var metodo = "post";
                var urlCliente = this.URL;
                if (this.update == true) {
                    metodo = "put";
                    urlCliente += this.parametrosAP28.model.id + "/";
                }
                axios({
                        method: metodo,
                        url: urlCliente,
                        data: datos
                    })
                    .then(res => {
                        this.$swal({
                            type: "success",
                            title: "¡Operación Exitosa!",
                            text: "Los datos se guardaron correctamente",
                            footer: ""
                        });
                    })
                    .catch(error => {
                        var errores = "";
                        if (typeof error.response.data != "undefined") {
                            Object.keys(error.response.data).forEach(function (key) {
                                for (var k in error.response.data[key]) {
                                    errores += key + ": " + error.response.data[key][k];
                                    errores += "<br>";
                                }
                            });
                        }
                        this.$swal({
                            position: "center",
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al guardar los datos",
                            footer: errores
                            //showConfirmButton: false,
                        });
                        //console.log(error);
                    })
                    .then(() => {
                        this.cargarAP28();
                        this.$root.$dialogLoader.hide();
                        this.modalAP28 = false;
                    });
            }
        },        
        cargarAP28: function () {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');            
            var datos = {
                tabla: this.parametrosAP28.tabla,                
            };
            
            datos["cliente"]= this.id_cliente;

            axios
                .post(this.$hostname + this.parametrosAP28.url_list, datos)                                       
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.datosAP28.items = res.data;
                        var self = this;
                        var tipoUsuario = this.$local_storage.get("tipo_usuario");
                        
                    }
                })
                .catch(err => {
                  
                    console.log(err);
                })
                .then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },                
        getRegistroAP28: function (id_registro) {
            let tabla = this.parametrosAP28.tabla;
            this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
            axios
                .get(this.URL + id_registro + "/", {
                    params: {
                        tabla: tabla
                    }
                })
                .then(response => {
                    this.parametrosAP28.model = response.data;
                    var obj = response.data;
                    for (var [key, value] of Object.entries(obj)) {
                        if (Object.keys(this.parametrosAP28.form).includes(key))
                            this.parametrosAP28.form[key].value = value;
                    }
                    this.openModalAP28(2); //ACTUALIZAR
                })
                .catch(error => {
                    console.log(error);
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener el registro",
                        footer: ""
                    });
                })
                .then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        
        deleteRegistroAP28: function (id_registro) {
            let tabla = this.parametrosAP28.tabla;
            this.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Está seguro de eliminar el registro?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar"
            }).then(result => {
                if (result.value) {
                    this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
                    axios
                        .delete(this.URL + id_registro + "/", {
                            params: {
                                tabla: tabla
                            }
                        })
                        .then(response => {
                            this.cargarAP28();
                            this.$swal({
                                type: "success",
                                title: "Operación Exitosa",
                                text: "El registro se eliminó correctamente.",
                                //position: 'bottom-end',
                                //timer: 3000,
                                //showConfirmButton: false,
                                footer: ""
                            });
                        })
                        .catch(error => {
                            console.log(error);
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al eliminar el registro",
                                footer: ""
                            });
                        })
                        .then(() => {
                            this.$root.$dialogLoader.hide();
                        });
                }
            });
        }, //delete
        deleteAll: async function (id_registro) {
            let tabla = this.parametrosAP28.tabla;
            var rfc = this.$local_storage.get("rfc")
            this.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Está seguro de eliminar todas las palabras clave de "+rfc+"?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar"
            }).then(async result => {
                if (result.value) {
                    this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");

                    var error_count = 0;

                    await Promise.all(this.datosAP28.items.map(async (doc) => {
                        await axios.delete(this.URL + doc.id + "/", {
                            params: {
                                tabla: tabla
                            }
                        }).catch(error => {
                            console.log(error);  
                            error_count += 1;                          
                        });
                    }));
                    

                    //this.$root.$dialogLoader.hide();
                    this.cargarAP28();
                    if(error_count > 0){
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Algunos registros no se eliminaron. Intente Nuevamente.",
                            footer: ""
                        });
                    } else {
                        this.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "Registros eliminados correctamente.",                        
                            footer: ""
                        });
                    }
                    
                }
            });
        },
        beforeUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (isLt2M) {
                return true;
            }
            this.$swal({
                type: "warning",
                title: "¡Operación no Permitida!",
                text: "El archivo no debe ser mayor a 2MB.",
                footer: ""
            });
            return false;
        },
        
        handleSuccessAP28({
            results,
            header
        }) {
            for (var k in results) {
                results[k]['cliente'] = this.id_cliente;
                //console.log("Key is " + k + ", value is" + results[k]);  
            }            
            this.importData = results;

            this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
            let tabla = this.parametrosAP28.tabla;
            axios
                .post(this.URL + "importar_apendice/?tabla=" + tabla, this.importData)
                .then(() => {
                    this.$swal({
                        type: "success",
                        title: "¡Operación Exitosa!",
                        text: "Los datos se guardaron correctamente",
                        footer: ""
                    });
                })
                .catch(err => {
                    var errores = "";
                    if (typeof err.response.data != "undefined") {
                        for (var i = 0; i < err.response.data.length; i++) {
                            Object.keys(err.response.data[i]).forEach(function (key) {
                                errores +=
                                    "Fila " +
                                    (i + 2) +
                                    " => " +
                                    key +
                                    ": " +
                                    err.response.data[i][key];
                                errores += "<br>";
                            });
                        }
                    }
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Verifique que los encabezados correspondan con el layout y que no existan registros duplicados.",
                        footer: errores
                    });
                })
                .then(() => {
                    this.$root.$dialogLoader.hide();
                    this.cargarAP28();
                    
                });
        },

    }, //methods

    created: function () {
        this.id_cliente = this.$local_storage.get("id_cliente");
        var tipoUsuario = this.$local_storage.get("tipo_usuario");  
        
        if (tipoUsuario=="Soporte" || tipoUsuario=="Super Usuario"){
            this.permisoEliminarTodos = true;
        }
                
        this.URL = this.$hostname + this.parametrosAP28.url_actions;                    
        
        this.editable = false;            
        this.cargarAP28();
                
    }
};
</script>

<style>
.VueTables__limit {
    display: none;
}
</style>
<style scoped>
.VueTables >>> thead th {
  white-space: normal !important;
}

.VueTables >>> tbody td{
  white-space: normal !important;
}
</style>
<style scoped>
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active),
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-icon,
.theme--light.v-tabs>.v-tabs-bar .v-tab--disabled {
  color: black;
  font-size: small;
  background-color: #EEEEEE;
  padding: 0px;
}

.v-tabs .v-tabs-bar .v-tab.v-tab--active {
  color: white;
  font-size: small;
  background-color: #df7205;
  padding: 0px;
  font-weight: bold;

}

.v-tabs-slider-wrapper {
  left: 0 !important;
}

.table-bordered thead th,
.table-bordered thead td {
  font-size: x-small !important;
}
</style>
